// Mirrors fhx DataUtil.IsTestStringID: test IDs carry the TST prefix (00TST for the
// long-width form), distinguished by ID length.
const testIdPrefix = 'TST'
const testLongIdPrefix = '00' + testIdPrefix

export function isTestStringId(id: string | undefined) {
    if (!id) {
        return false
    }
    if (id.length === 8) {
        return id.startsWith(testLongIdPrefix)
    }
    if (id.length === 4 || id.length === 6) {
        return id.startsWith(testIdPrefix)
    }
    return false
}
